var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79 79",
    style: {
      enableBackground: "new 0 0 79 79"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6E7E8;}\n\t.st1{fill:#6D6E71;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.5,79C17.72,79,0,61.28,0,39.5S17.72,0,39.5,0S79,17.72,79,39.5S61.28,79,39.5,79z M39.5,7.18 c-17.82,0-32.32,14.5-32.32,32.32s14.5,32.32,32.32,32.32s32.32-14.5,32.32-32.32S57.32,7.18,39.5,7.18z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.5,71.82V79C61.28,79,79,61.28,79,39.5h-7.18C71.82,57.32,57.32,71.82,39.5,71.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.5,7.18V0C17.72,0,0,17.72,0,39.5h7.18C7.18,21.68,21.68,7.18,39.5,7.18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderCircle);
export default __webpack_public_path__ + "static/media/loader-circle.69419905bd92644454ac581203ce21a8.svg";
export { ForwardRef as ReactComponent };